import { render, staticRenderFns } from "./HomeSchema.vue?vue&type=template&id=7ed1cad4"
import script from "./HomeSchema.vue?vue&type=script&lang=js"
export * from "./HomeSchema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports